// extracted by mini-css-extract-plugin
export default {"Home":"styles_Home__09IEB","row":"styles_row__OtQEG"};